module.exports = __webpack_public_path__ + "static/32DCAF_0_0-765e1b12acc5b6abb473435d6e4c7050.woff";